import React, { useRef, useEffect } from 'react';
import { Message, DefaultMessage } from 'src/model/chat-bot';
import ChatBotLoader from '../chat-bot-loader';
import { ActionButtons } from './action-buttons';
import { defaultMessages } from '@src/components/shared/chat-bot/chat-bot.constants';
import { sanitizeHtml } from '@src/utils/chat-bot-utils';

interface MessageListProps {
    messages: Message[];
    isAgentLoading: boolean;
    isInitial: boolean;
    showActionButtons: boolean;
    onActionButtonClick: (m: DefaultMessage) => void;
}

export const MessageList: React.FC<MessageListProps> = ({
    messages,
    isAgentLoading,
    isInitial,
    showActionButtons,
    onActionButtonClick
}) => {
    const endRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        endRef.current?.scrollIntoView({behavior: 'smooth'});
    }, [messages, isAgentLoading, showActionButtons]);

    return (
        <div className="chat-body-content" role="log" aria-live="polite">
            {messages.map((msg, index) => (
                <div key={`${msg.sender}-${index}`} className={`message ${msg.sender}`} dangerouslySetInnerHTML={{__html: sanitizeHtml(msg.text).trim()}}/>
            ))}
            {isAgentLoading && <span className="processing"><ChatBotLoader/> Processing...</span>}
            {showActionButtons && !isAgentLoading && (
                <ActionButtons
                    defaultMessages={defaultMessages}
                    isInitial={isInitial}
                    onClick={onActionButtonClick}
                />
            )}
            {!isInitial && <div ref={endRef}></div>}
        </div>
    );
};
